import React, { Component } from "react";
import styled from "styled-components";
import Tracking from "src/react/components/tracking";
import { LabelEl, InputEl, TextAreaEl } from "src/react/forms/styles";
import { PasswordInput } from "./password-input";

export class Input extends Component {
  renderInput() {
    const {
      field: { name, value, onChange, onBlur },
      form: { errors, touched } = { errors: {}, touched: {} },
      type = "text",
      inline,
      innerRef,
      wrapperCss,
      ...rest
    } = this.props;

    const hasValue = value !== "";
    const isValid = touched[name] != null && hasValue && errors[name] == null;
    const isInvalid = touched[name] != null && errors[name] != null;
    const inputProps = {
      id: name,
      name,
      value,
      onChange,
      onBlur,
      hasValue,
      isValid,
      isInvalid,
      ref: innerRef,
      ...rest,
    };

    switch (type) {
      case "textarea":
        return (
          <TextAreaEl
            {...inputProps}
            autoComplete="off"
            autoCapitalize="off"
            autoCorrect="off"
          />
        );

      case "email":
        return (
          <InputEl
            {...inputProps}
            type="email"
            autoComplete="off"
            autoCapitalize="off"
            autoCorrect="off"
          />
        );

      case "password":
        return <PasswordInput {...inputProps} />;

      case "date":
        return (
          <InputEl
            {...inputProps}
            type="date"
            autoComplete="off"
            autoCapitalize="off"
            autoCorrect="off"
          />
        );

      case "input":
        return (
          <InputEl
            {...inputProps}
            type="input"
            autoComplete="off"
            autoCapitalize="off"
            autoCorrect="off"
          />
        );

      default:
        return <InputEl type={type} {...inputProps} />;
    }
  }

  render() {
    const {
      field: { name, value },
      label = "",
      inline,
      tracking,
      trackingOptions,
      wrapperCss,
    } = this.props;
    const hasValue = value !== "";
    return (
      <Wrapper inline={inline} wrapperCss={wrapperCss}>
        {label && (
          <LabelEl htmlFor={name} float={hasValue}>
            {label}
          </LabelEl>
        )}
        <Tracking
          trackOnFocus
          tracking={tracking}
          trackingOptions={trackingOptions}
        >
          {this.renderInput()}
        </Tracking>
      </Wrapper>
    );
  }
}

export function StandardInput({ label = "", value, inline, ...props }) {
  const hasValue = value != null && value !== "";
  return (
    <Wrapper inline={inline}>
      {label && <LabelEl visible={hasValue}>{label}</LabelEl>}
      <InputEl
        value={value}
        autoComplete="off"
        autoCapitalize="off"
        autoCorrect="off"
        {...props}
      />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  ${({ inline }) => inline && `display: inline-block; margin-right: 15px;`};
  ${({ wrapperCss }) => wrapperCss};
`;
